import { getUrlParamsFetch, urlBackend } from '@/shared';
import { erpApi } from '@/shared/axios/erp-api';
import {
  ICuentaContable,
  ICuentaContableFiltros,
  IDataCuentaContable,
  IDtaPlanCuentas,
  IDtaPlanCuentasParams,
  IPlanCuenta,
} from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const { get, post, put, remove } = erpApi();

type CreateCuentaContable = Omit<IDataCuentaContable, 'id_cuenta_contable'>;

//CREAR CUENTAS CONTABLES
export const useFetchCrearCuentasContables = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postCuentaContable,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cuentas-contables'] });
    },
  });
};

export const postCuentaContable = async (data: CreateCuentaContable) => {
  return post<IDataCuentaContable>(
    `${urlBackend}api/v1/cuentas-contables/`,
    data,
    true
  );
};

//OBTENER CUENTAS CONTABLES

export const useFetchObtenerCuentasContables = (
  params?: ICuentaContableFiltros
) => {
  return useQuery({
    queryKey: ['cuentas-contables', ...Object.values(params || {})],
    queryFn: async () => {
      return getCuentasContables(params);
    },
  });
};

export const getCuentasContables = async (params?: ICuentaContableFiltros) => {
  const queryParams = getUrlParamsFetch(params || {});
  return get<ICuentaContable>(
    `${urlBackend}api/v1/cuentas-contables/?${queryParams}`,
    true
  );
};

//CREAR PLAN CUENTA

export const useFetchCrearPlanCuenta = () => {
  const setAlert = useUiStore.getState().setAlert;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postPlanCuenta,
    onSuccess: e => {
      queryClient.invalidateQueries({ queryKey: ['plan-cuenta'] });
      setAlert(true, e.message, e.status);
    },
  });
};

export const postPlanCuenta = async (data: IDtaPlanCuentasParams) => {
  return post<IDtaPlanCuentas>(`${urlBackend}api/v1/plancuenta/`, data, true);
};

//OBTENER PLAN CUENTA POR ID

export const useFetchgetPlanCuentaById = (id: number) => {
  return useQuery({
    queryKey: ['cuentas-contables', id],
    queryFn: async () => {
      return getPlanCuentaById(id);
    },
  });
};

export const getPlanCuentaById = async (id: number) => {
  return get<IDtaPlanCuentas>(`${urlBackend}api/v1/plancuenta/${id}`, true);
};

//OBTENER PLAN DE CUENTA POR ID_EMPRESA
export const useFetchgetPlanCuentaByEmpresa = (id: string, enabled = false) => {
  return useQuery({
    queryKey: ['cuentas-contables', id],
    queryFn: async () => {
      return getPlanCuentaByEmpresa(id);
    },
    enabled: enabled
  });
};
//esto debe estar por empresa
export const getPlanCuentaByEmpresa = async (_id?: string) => {
  const resp = await get<IPlanCuenta>(
    `${urlBackend}api/v1/plancuenta/`,
    true
  );


  return resp.data.data[0];
};

//EDITAR PLAN DE CUENTAS

export const useFetchEditarPlanCuenta = () => {
  const setAlert = useUiStore.getState().setAlert;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: IDtaPlanCuentasParams }) => {
      return putPlanCuenta(id, data);
    },
    onSuccess: e => {
      queryClient.invalidateQueries({ queryKey: ['plan-cuenta'] });
      setAlert(true, e.message, e.status);
    },
  });
};

export const putPlanCuenta = async (id: string, data: IDtaPlanCuentasParams) => {
  return put<IDtaPlanCuentas>(
    `${urlBackend}api/v1/plancuenta/${id}/`,
    data,
    true
  );
};

//ELIMIAR CUENTA CONTABLE

export const deletePlanCuenta = async (id: number) => {
  return remove<IDtaPlanCuentas>(`${urlBackend}api/v1/plancuenta/${id}/`, true);
};
